import React from 'react';
import {
  FaInstagram,
  FaFacebook,
  FaTiktok,
  FaYoutube,
  FaPinterest,
} from 'react-icons/fa';
import { isValid } from '../../../utils';
import './about-us.scss';

const AudienceHighlightsAndSocial = ({
  isSocial,
  isHighlights,
}) => {
  let wrapperClass = null;
  if (isHighlights) {
    wrapperClass = 'highlights-wrapper';
  } if (isSocial) {
    wrapperClass = 'social-wrapper';
  }

  const highlightsData = [
    {
      social: 'pinterest',
      reach: '1.75M',
    },
    {
      social: 'instagram',
      reach: '16.7M',
    },
    {
      social: 'facebook',
      reach: '6.5M',
    },
    {
      social: 'tiktok',
      reach: '15M',
    },
  ];
  const socialChannels = ['tiktok', 'instagram', 'pinterest', 'facebook', 'youtube'];

  const renderedHighlights = highlightsData.map((highlight) => {
    const { social, reach } = highlight;
    const channel = isValid(social) ? social : null;
    const audience = isValid(reach) ? reach : null;
    return (
      <>
        <div className='highlight-item'>
          <div className='circle'>
            <div className='audience-reach'>{audience}</div>
          </div>
          <h3 className='channel-label'>{channel}</h3>
        </div>
      </>
    );
  });

  const renderedChannels = socialChannels.map((channel, i) => {
    return (
        <>
          <div className='social-item' id={channel}>
            {(channel === 'tiktok') && 
              <a className='social-item-link' href='https://www.tiktok.com/@purewow' target='_blank'>
                <div className='circle'>
                <FaTiktok className='social-link'></FaTiktok>
                </div>
              </a>
            }
            {(channel === 'instagram') && 
              <a className='social-item-link' href='https://www.instagram.com/purewow' target='_blank'>
                <div className='circle'>
                <FaInstagram className='social-link'></FaInstagram>
                </div>
              </a>
            }
            {(channel === 'pinterest') && 
              <a className='social-item-link' href='https://pinterest.com/purewow' target='_blank'>
                <div className='circle'>
                <FaPinterest className='social-link'></FaPinterest>
                </div>
              </a>
            }
            {(channel === 'facebook') && 
              <a className='social-item-link' href='https://www.facebook.com/PureWow' target='_blank'>
                <div className='circle'>
                <FaFacebook className='social-link'></FaFacebook>
                </div>
              </a>
            }
            {(channel === 'youtube') && 
              <a className='social-item-link' href='https://www.youtube.com/user/PureWowVideos' target='_blank'>
                <div className='circle'>
                <FaYoutube className='social-link'></FaYoutube>
                </div>
              </a>
            }
            <div className='channel-label'>{channel}</div>
          </div>
        </>
    );
  });

  return (
    <>
      <div className={wrapperClass}>
        {isHighlights && renderedHighlights}
        {isSocial && renderedChannels}
      </div>
    </>
  );
};

export default AudienceHighlightsAndSocial;
